import type { Location } from "vue-router";
import { listProofreadingWorkManuscripts } from "@/lib/api/proofreading";
import { useProofreadingBasicStore } from "@/stores/proofreadingBasic";
import { useProofreadingAiStore } from "@/stores/proofreadingAi";
import { isAiProofreadingReviseContext } from "@/lib/utils/proofreadingReviseMode";

/**
 * 修正反映画面へ直接入ったとき、ウィザード前提が揃っていなければ戻す先を決める。
 * 原稿選択も work も無い場合はタイプ選択（校正トップ）へ。
 *
 * AI 結果のレビューは work 作成前（finish 直後）にも入るため、
 * 判定条件は画面側の `isAiReviseMode` と揃える。
 */
export async function resolveProofreadingReviseRouteRedirect(
  novelId: string,
  options: { routeMode?: unknown } = {},
): Promise<Location | null> {
  const aiStore = useProofreadingAiStore();
  if (
    isAiProofreadingReviseContext({
      novelId,
      routeMode: options.routeMode,
      aiResult: aiStore.aiResult,
    })
  ) {
    return null;
  }

  const store = useProofreadingBasicStore();
  const { manuscriptIds } = await listProofreadingWorkManuscripts(novelId);
  const hasWork = manuscriptIds.length > 0;
  const hasSelectedManuscripts = store.selectedManuscriptKeys.length > 0;

  if (!hasWork && !hasSelectedManuscripts) {
    return {
      name: "proofreadingSelectType",
      params: { novelId },
    };
  }

  return null;
}
